if(!customElements.get('stack-blocks')) {

  class StackBlocks extends HTMLElement {
    constructor() {
      super();
      
      if (window.innerWidth < 769) {
        return;
      }

      this.el = {
        section: '.stack-blocks',
        stickyCnt: '.stack-blocks-sticky',
        blockInfo: '.stack-block-info-item',
        activeBlockInfo: '.stack-block-info-item.active',
        blockMedia: '.section-block-media-item',
        activeBlockMedia: '.section-block-media-item:not(.desktop-hidden)'
      }

      this.section = document.querySelector(this.el.section);
      this.stickyCnt = document.querySelector(this.el.stickyCnt);

      this.count = this.section.querySelectorAll(this.el.blockInfo).length;

      this.windowHeight = window.innerHeight;
      this.sectionOffset = this.section.offsetTop;
      this.sectionHeight = this.section.getBoundingClientRect().height;
      this.step = this.sectionHeight;
      this.stickyPos = (this.windowHeight - this.sectionHeight) / 2;
      this.startPos = this.sectionOffset - this.stickyPos;

      this.blockVisibleHandler();

      window.addEventListener('scroll', () => {
        this.blockVisibleHandler();
      })
    }
  
    blockVisibleHandler() {

      if(!this.section.classList.contains('initialized')) {
        this.section.classList.add('initialized');
        this.section.style.height = `${this.count * this.step + this.stickyPos}px`;
        this.stickyCnt.style.top = `${this.stickyPos}px`;
      }

      let scrollTop = document.documentElement.scrollTop;
      let index = Math.ceil((scrollTop - this.startPos) / this.step);

      if(index > 0 && index <= this.count) {
        document.querySelector(this.el.activeBlockInfo).classList.remove('active');
        document.querySelector(this.el.activeBlockMedia).classList.add('desktop-hidden');
        document.querySelector(`${this.el.blockInfo}[data-index="${index}"]`).classList.add('active');
        document.querySelector(`${this.el.blockMedia}[data-index="${index}"]`).classList.remove('desktop-hidden');
      }

    }

  }
  
  customElements.define('stack-blocks', StackBlocks);

}
